import { createFeatureSelector, createSelector } from '@ngrx/store';

import { layoutFeatureKey, State } from '../reducers/layout.reducer';

export const selectLayoutFeature = createFeatureSelector<State>(layoutFeatureKey);

export const selectUseMobileLayout = createSelector(selectLayoutFeature, (state: State) => state.useMobileLayout);
